<template>
  <div class="modal-overlay" @click.self="closeModal">
    <div class="modal-container">
      <div class="modal-header">
        <h3>{{ isLogin ? '用户登录' : '用户注册' }}</h3>
        <button class="close-button" @click="closeModal">
          <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M18 6L6 18" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
            <path d="M6 6L18 18" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
        </button>
      </div>

      <div class="modal-body">
        <!-- 登录表单 -->
        <div v-if="isLogin">
          <div class="login-options">
            <div class="login-option" @click="loginWithWechat">
              <div class="login-icon wechat-icon">
                <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M9.5 8.5C9.5 7.67157 8.82843 7 8 7C7.17157 7 6.5 7.67157 6.5 8.5C6.5 9.32843 7.17157 10 8 10C8.82843 10 9.5 9.32843 9.5 8.5Z" fill="currentColor"/>
                  <path d="M17.5 14.5C17.5 13.6716 16.8284 13 16 13C15.1716 13 14.5 13.6716 14.5 14.5C14.5 15.3284 15.1716 16 16 16C16.8284 16 17.5 15.3284 17.5 14.5Z" fill="currentColor"/>
                  <path d="M14.5 8.5C14.5 7.67157 13.8284 7 13 7C12.1716 7 11.5 7.67157 11.5 8.5C11.5 9.32843 12.1716 10 13 10C13.8284 10 14.5 9.32843 14.5 8.5Z" fill="currentColor"/>
                  <path d="M9.5 14.5C9.5 13.6716 8.82843 13 8 13C7.17157 13 6.5 13.6716 6.5 14.5C6.5 15.3284 7.17157 16 8 16C8.82843 16 9.5 15.3284 9.5 14.5Z" fill="currentColor"/>
                  <path fill-rule="evenodd" clip-rule="evenodd" d="M19.5 10.79C19.5 7.46979 16.2614 4.75 12.25 4.75C8.23858 4.75 5 7.46979 5 10.79C5 12.5292 5.75212 14.1071 7 15.2639V16.75C7 17.1642 7.33579 17.5 7.75 17.5H8.25C8.66421 17.5 9 17.1642 9 16.75V16H15V16.75C15 17.1642 15.3358 17.5 15.75 17.5H16.25C16.6642 17.5 17 17.1642 17 16.75V15.2639C18.2479 14.1071 19 12.5292 19.5 10.79ZM12.25 6.25C15.4256 6.25 18 8.30979 18 10.79C18 13.2702 15.4256 15.33 12.25 15.33C9.07436 15.33 6.5 13.2702 6.5 10.79C6.5 8.30979 9.07436 6.25 12.25 6.25Z" fill="currentColor"/>
                </svg>
              </div>
              <span>微信登录</span>
            </div>

            <div class="login-option" @click="loginWithQQ">
              <div class="login-icon qq-icon">
                <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path fill-rule="evenodd" clip-rule="evenodd" d="M11.9903 4C16.0214 4 19.2953 7.27394 19.2953 11.305C19.2953 11.5148 19.2903 11.7226 19.2804 11.9283C19.5074 12.0271 19.7245 12.1458 19.9286 12.2827C20.5704 12.7085 21 13.4525 21 14.2744C21 15.0963 20.5704 15.8403 19.9286 16.2661C19.5889 16.4826 19.2023 16.6128 18.8007 16.6486C18.1919 18.1438 17.0802 19.4136 15.6739 20.2134C15.5211 20.3 15.3361 20.3 15.1833 20.2134C15.0305 20.1268 14.938 19.9536 14.938 19.7671V18.2719C14.4358 18.4584 13.9039 18.5883 13.3522 18.6616C13.0125 18.7049 12.6629 18.7249 12.3033 18.7249H11.6773C11.3177 18.7249 10.9681 18.7049 10.6284 18.6616C10.0767 18.5883 9.54481 18.4584 9.04258 18.2719V19.7671C9.04258 19.9536 8.95009 20.1268 8.79729 20.2134C8.64449 20.3 8.45951 20.3 8.30671 20.2134C6.90039 19.4136 5.78871 18.1438 5.17992 16.6486C4.77831 16.6128 4.39172 16.4826 4.05201 16.2661C3.41023 15.8403 2.98062 15.0963 2.98062 14.2744C2.98062 13.4525 3.41023 12.7085 4.05201 12.2827C4.25613 12.1458 4.47324 12.0271 4.70025 11.9283C4.69033 11.7226 4.68537 11.5148 4.68537 11.305C4.68537 7.27394 7.95929 4 11.9903 4ZM11.9903 5.66667C8.87845 5.66667 6.35204 8.19307 6.35204 11.305C6.35204 11.5581 6.36196 11.8071 6.38181 12.052C6.39173 12.1819 6.35204 12.3118 6.27447 12.4184C6.19691 12.525 6.08457 12.6016 5.95737 12.6316C5.73036 12.6883 5.51325 12.7749 5.31335 12.8915C5.01392 13.0747 4.84619 13.3669 4.84619 13.6824V14.8664C4.84619 15.1819 5.01392 15.4741 5.31335 15.6573C5.51325 15.7739 5.73036 15.8605 5.95737 15.9172C6.08457 15.9471 6.19691 16.0238 6.27447 16.1304C6.35204 16.237 6.39173 16.3669 6.38181 16.4968C6.92358 18.5883 8.7969 20.1268 11.0159 20.1268C11.3456 20.1268 11.6674 20.0969 11.9803 20.037C12.2932 20.0969 12.615 20.1268 12.9447 20.1268C15.1637 20.1268 17.037 18.5883 17.5788 16.4968C17.5689 16.3669 17.6086 16.237 17.6861 16.1304C17.7637 16.0238 17.876 15.9471 18.0032 15.9172C18.2302 15.8605 18.4473 15.7739 18.6472 15.6573C18.9467 15.4741 19.1144 15.1819 19.1144 14.8664V13.6824C19.1144 13.3669 18.9467 13.0747 18.6472 12.8915C18.4473 12.7749 18.2302 12.6883 18.0032 12.6316C17.876 12.6016 17.7637 12.525 17.6861 12.4184C17.6086 12.3118 17.5689 12.1819 17.5788 12.052C17.5986 11.8071 17.6086 11.5581 17.6086 11.305C17.6086 8.19307 15.0822 5.66667 11.9903 5.66667ZM9.04258 10.4719C9.04258 9.82012 9.56473 9.29797 10.2165 9.29797C10.8683 9.29797 11.3904 9.82012 11.3904 10.4719C11.3904 11.1237 10.8683 11.6459 10.2165 11.6459C9.56473 11.6459 9.04258 11.1237 9.04258 10.4719ZM12.5902 10.4719C12.5902 9.82012 13.1124 9.29797 13.7642 9.29797C14.416 9.29797 14.9381 9.82012 14.9381 10.4719C14.9381 11.1237 14.416 11.6459 13.7642 11.6459C13.1124 11.6459 12.5902 11.1237 12.5902 10.4719Z" fill="currentColor"/>
                </svg>
              </div>
              <span>QQ登录</span>
            </div>

            <div class="login-option" @click="showPhoneLogin = true">
              <div class="login-icon phone-icon">
                <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M16 2H8C6.89543 2 6 2.89543 6 4V20C6 21.1046 6.89543 22 8 22H16C17.1046 22 18 21.1046 18 20V4C18 2.89543 17.1046 2 16 2Z" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                  <path d="M12 18H12.01" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                </svg>
              </div>
              <span>手机号登录</span>
            </div>
          </div>

          <div v-if="showPhoneLogin" class="phone-login-form">
            <div class="form-group">
              <label for="phone">手机号</label>
              <input
                type="tel"
                id="phone"
                v-model="phone"
                placeholder="请输入手机号"
                maxlength="11"
              >
            </div>

            <div class="form-group">
              <label for="password">密码</label>
              <input
                type="password"
                id="password"
                v-model="password"
                placeholder="请输入密码"
              >
            </div>

            <div class="form-actions">
              <button class="login-button" @click="loginWithPhone">登录</button>
              <div class="register-link">
                <span>没有账号？</span>
                <a href="#" @click.prevent="switchToRegister">立即注册</a>
              </div>
            </div>
          </div>
        </div>

        <!-- 注册表单 -->
        <div v-else class="register-form">
          <div class="form-group">
            <label for="reg-phone">手机号</label>
            <input
              type="tel"
              id="reg-phone"
              v-model="phone"
              placeholder="请输入手机号"
              maxlength="11"
            >
          </div>

          <div class="form-group verification-code">
            <label for="code">验证码</label>
            <div class="code-input-group">
              <input
                type="text"
                id="code"
                v-model="verificationCode"
                placeholder="请输入验证码"
                maxlength="4"
              >
              <button
                class="send-code-button"
                @click="sendVerificationCode"
                :disabled="countdown > 0"
              >
                {{ countdown > 0 ? `${countdown}秒后重发` : '获取验证码' }}
              </button>
            </div>
          </div>

          <div class="form-group">
            <label for="reg-password">设置密码</label>
            <input
              type="password"
              id="reg-password"
              v-model="password"
              placeholder="请设置密码"
            >
          </div>

          <div class="form-group">
            <label for="confirm-password">确认密码</label>
            <input
              type="password"
              id="confirm-password"
              v-model="confirmPassword"
              placeholder="请再次输入密码"
            >
          </div>

          <div class="form-actions">
            <button class="register-button" @click="register">注册</button>
            <div class="login-link">
              <span>已有账号？</span>
              <a href="#" @click.prevent="switchToLogin">立即登录</a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      // 状态变量
      isLogin: true,
      showPhoneLogin: false,
      phone: '',
      password: '',
      verificationCode: '',
      confirmPassword: '',
      countdown: 0
    }
  },
  methods: {
    // 关闭模态框
    closeModal() {
      this.$emit('close')
    },

    // 切换到注册页面
    switchToRegister() {
      this.isLogin = false
      this.resetForm()
    },

    // 切换到登录页面
    switchToLogin() {
      this.isLogin = true
      this.showPhoneLogin = false
      this.resetForm()
    },

    // 重置表单
    resetForm() {
      this.phone = ''
      this.password = ''
      this.verificationCode = ''
      this.confirmPassword = ''
    },

    // 微信登录
    loginWithWechat() {
      console.log('微信登录')
      // 实现微信登录逻辑
      // 通常会打开一个新窗口或跳转到微信授权页面
    },

    // QQ登录
    loginWithQQ() {
      console.log('QQ登录')
      // 实现QQ登录逻辑
      // 通常会打开一个新窗口或跳转到QQ授权页面
    },

    // 手机号登录
    loginWithPhone() {
      console.log('手机号登录', this.phone, this.password)
      // 实现手机号登录逻辑
    },

    // 发送验证码
    sendVerificationCode() {
      if (this.phone.length !== 11) {
        alert('请输入正确的手机号')
        return
      }

      console.log('发送验证码到', this.phone)

      // 开始倒计时
      this.countdown = 60
      const timer = setInterval(() => {
        this.countdown--
        if (this.countdown <= 0) {
          clearInterval(timer)
        }
      }, 1000)
    },

    // 注册
    register() {
      if (this.password !== this.confirmPassword) {
        alert('两次输入的密码不一致')
        return
      }

      console.log('注册新用户', this.phone, this.password)
      // 实现注册逻辑
    }
  }
}
</script>

<style scoped>
.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
}

.modal-container {
  background-color: white;
  border-radius: 12px;
  width: 400px;
  max-width: 90%;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.15);
  overflow: hidden;
}

.modal-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 16px 20px;
  border-bottom: 1px solid #e5e7eb;
}

.modal-header h3 {
  margin: 0;
  font-size: 18px;
  color: #1f2937;
}

.close-button {
  background: transparent;
  border: none;
  cursor: pointer;
  width: 24px;
  height: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #6b7280;
}

.close-button:hover {
  color: #1f2937;
}

.close-button svg {
  width: 20px;
  height: 20px;
}

.modal-body {
  padding: 20px;
}

.login-options {
  display: flex;
  flex-direction: column;
  gap: 16px;
  margin-bottom: 20px;
}

.login-option {
  display: flex;
  align-items: center;
  padding: 12px 16px;
  border-radius: 8px;
  border: 1px solid #e5e7eb;
  cursor: pointer;
  transition: all 0.2s;
}

.login-option:hover {
  background-color: #f3f4f6;
  border-color: #d1d5db;
}

.login-icon {
  width: 24px;
  height: 24px;
  margin-right: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.wechat-icon {
  color: #07c160;
}

.qq-icon {
  color: #12b7f5;
}

.phone-icon {
  color: #2563eb;
}

.login-option span {
  font-size: 16px;
  color: #1f2937;
}

.phone-login-form, .register-form {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.form-group {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.form-group label {
  font-size: 14px;
  color: #4b5563;
}

.form-group input {
  padding: 10px 12px;
  border-radius: 6px;
  border: 1px solid #d1d5db;
  font-size: 16px;
  outline: none;
  transition: border-color 0.2s;
}

.form-group input:focus {
  border-color: #2563eb;
  box-shadow: 0 0 0 3px rgba(37, 99, 235, 0.1);
}

.verification-code .code-input-group {
  display: flex;
  gap: 8px;
}

.verification-code input {
  flex: 1;
}

.send-code-button {
  padding: 0 12px;
  border-radius: 6px;
  border: 1px solid #2563eb;
  background-color: white;
  color: #2563eb;
  font-size: 14px;
  cursor: pointer;
  white-space: nowrap;
  transition: all 0.2s;
}

.send-code-button:hover:not(:disabled) {
  background-color: #eff6ff;
}

.send-code-button:disabled {
  border-color: #d1d5db;
  color: #9ca3af;
  cursor: not-allowed;
}

.form-actions {
  display: flex;
  flex-direction: column;
  gap: 12px;
  margin-top: 8px;
}

.login-button, .register-button {
  padding: 12px;
  border-radius: 6px;
  border: none;
  background-color: #2563eb;
  color: white;
  font-size: 16px;
  font-weight: 500;
  cursor: pointer;
  transition: background-color 0.2s;
}

.login-button:hover, .register-button:hover {
  background-color: #1d4ed8;
}

.register-link, .login-link {
  text-align: center;
  font-size: 14px;
  color: #6b7280;
}

.register-link a, .login-link a {
  color: #2563eb;
  text-decoration: none;
  margin-left: 4px;
}

.register-link a:hover, .login-link a:hover {
  text-decoration: underline;
}
</style>
